import logo from '../assets/logo.webp'

interface LogoProps {
  className?: string
}

export default function Logo({ className }: LogoProps) {
  return (
    <img src={logo} alt="Logo" width={64} height={64} className={className} />
  )
}
